export enum DashboardActionKeys {
  FETCH_SALES_DASHBOARD = 'FETCH_SALES_DASHBOARD',
  SET_SALES_DASHBOARD = 'SET_SALES_DASHBOARD'
}
